import React, { useState, useEffect } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import Button from '@material-ui/core/Button';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import ictchallenges from "assets/img/ictchallenges.jpg";
import Ads1 from "views/Main/Sections/Ads1";
import Ads4 from "views/Main/Sections/Ads4";


import styles from "assets/jss/material-kit-react/views/ictchallengesEvent.js";
import { string } from "prop-types";

const useStyles = makeStyles(styles);

export default function ICTChallengesMainPage(props) {
    const classes = useStyles();

    const { ...rest } = props;
    const imageClasses = classNames(
        classes.imgRaised,
        classes.imgRoundedCircle,
        classes.imgFluid
    );
    return (
        <div>
            <Header
                color="transparent"
                brand="Material Kit React"
                rightLinks={<HeaderLinks />}
                fixed
                changeColorOnScroll={{
                    height: 200,
                    color: "white"
                }}
                {...rest}
            />
            <Parallax small filter image={require("assets/img/bg.jpg")} />
            <div className={classNames(classes.main, classes.mainRaised)}>
                <div>
                    <div className={classes.container}>

                        <GridContainer justify="center" className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.topdev}>
                                    <div>
                                        <img src={ictchallenges} alt="..." className={imageClasses} />
                                    </div>
                                    <div className={classes.name}>
                                        <h3 className={classes.title}>مسابقه چالش های حوزه فناوری اطلاعات و ارتباطات</h3>
                                        <div className={classes.description}>
                                            <p>
                                        رویدادهای ICT Challenge مجموعه مسابقاتی با هدف شناسایی افراد مستعد و توانمند در حوزه ICT می باشد. این رویداد ها تحت یک سری قوانین خاص و در جهت حل چالش های موجود در حوزه فناوری اطلاعات و ارتباطات برگزار می شوند و شرکت کنندگان در این مسابقات جهت اشتغال به شرکت های فعال این حوزه معرفی خواهند شد.
                                        </p>
                                        <p>
در هر کدام از این رویداد ها یک چالش خاص در حوزه ICT مورد هدف قرار گرفته و یک مسابقه برای حل این چالش برگزار میشود. 
</p>

</div>
<br />
                                    <p>
                                    <Button variant="outlined"  color="secondary" href="/ICTChallenge/Event"  disableElevation>
                                         سامانه هشتمین دوره مسابقه چالش های فناوری اطلاعات و ارتباطات
                                    </Button>
                                    <br />
                                    <br />
                                    <Button variant="outlined" target='_blank' href="http://ictchallenge.sharif.ir/"  disableElevation>
                                         وب سایت مسابقه چالش های حوزه فناوری اطلاعات و ارتباطات
                                    </Button>
                                    </p>
                                    </div>
                                </div>
                        {
                        //<Ads1/>
                        //<Ads4/>
                        }
                            </GridItem>
                        </GridContainer>

                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <h2>روند شکل گیری</h2>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                            <div className={classes.description}>
<p>
                                <strong>
                                انتخاب چالش ها (کمیته ارتباط با صنعت)
                                </strong>
                                </p>
<p>
اولین مرحله در برگزاری رویداد ها مشخص کردن دقیق چالش اصلی مسابقه می باشد.
</p>
<p>
با توجه به هدف اصلی رویداد که شناسایی افراد توانمند جویای کار و ورود این افراد به بازار کار می باشد، چالش ها طوری انتخاب میشوند که بعد از برگزاری رویداد موضوعی واقعی و مطرح در صنعت حل شده باشد و امکان جذب شرکت کنندگان برتر در صنعت فراهم شود.
</p>
<p>
در این راستا کمیته ارتباط با صنعت متشکل از شرکت ها، سازمان ها و ارگان های فعال در این حوزه تشکیل میشود. این مجموعه ها چالش های اصلی در حوزه فعالیت خود را مطرح می کنند و پس از بررسی و مشورت چالش های اصلی مسابقه در این کمیته انتخاب می شود.
</p>
<p>
<br/>

<strong>
تشکیل پلتفرم مسابقه، ملاک های داوری و خروجی های مورد انتظار (کمیته علمی)
</strong>
</p>
<p>
پس از انتخاب چالش مورد نظر در کمیته ارتباط با صنعت نوبت به تعریف مسائل، پلتفرم مسابقه و مشخص کردن ملاک و معیار داوری مسابقه میرسد.
</p>
<p>
در این راستا کمیته علمی متشکل از اساتید دانشگاه، فعالین حوزه مورد نظر و … تشکیل شده که موارد بالا را مشخص می کنند.
</p>
<p>
    <br/>
<strong>
جذب افراد توانمند جهت شرکت در مسابقه و امور دبیرخانه ای (کمیته اجرایی)
</strong>
</p>
<p>
پس از مشخص شدن چالش ها، صورت مسئله، پلتفرم مسابقه و ملاک های داوری به بخش اصلی رویداد یعنی جذب افراد مستعد جهت شرکت در مسابقه و حل چالش های موجود می رسد. علاوه بر این مورد کلیه امور دبیرخانه ای، هماهنگی ها، تبلیغات و اطلاع رسانی رویداد، امور اجرایی روز مسابقه و … بر عهده کمیته اجرایی رویداد می باشد.
</p>
<p>
در این راستا کمیته اجرایی با راه اندازی دبیرخانه رویداد کلیه امور مربوط به این بخش را انجام خواهد داد.
</p>
                                </div>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <h2>روند برگزاری</h2>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.description}>
<p>
    <strong>مرحله اول (روز اول)</strong>
    </p>
<p>

در مرحله اول مهارت حل مسئله تیم ها مورد سنجش قرار میگیرد.
</p>
<p>
بدین صورت که شرکت کنندگان در ابتدای مسابقه تعدادی سوال که از چالش های واقعی در حوزه برنامه نویسی می باشد دریافت کرده و حدود 10 ساعت وقت برای حل این مسائل دارند. در کل این مدت تیم داوری و تیم منتور ها به صورت کامل در کنار شرکت کنندگان هستند و تیم ها را زیر نظر میگیرند.
</p>
<p>
تیم ها پس از حل مسائل پاسخ های خود را از طریق سامانه مسابقات به داوران ارسال میکنند.
</p>
<br />
<p>
    <strong>مرحله دوم (روز دوم)</strong>
</p>
<p>
در مرحله دوم خلاقیت، نوآوری و ایده پردازی تیم ها مورد سنجش قرار خواهد گرفت.
</p>
<p>
در روز دوم مسابقات تیم داوری رویداد کلیه تیم هایی که پاسخ مسائل را در سامانه داوری ثبت کرده اند را به ترتیب زمان ثبت پاسخ در سامانه جهت ارائه حضوری راه حل ها و دفاع از پاسخ های خود به محل مخصوص داوری مسابقات فرا می خوانند.
</p>
<p>
بدین صورت که هر تیم حدود 15 دقیقه وقت داده می شود تا به صورت حضوری با طراحان چالش ها به بحث و گفتگو بنشینند. 
</p>
<p>
لازم به ذکر است تیم داوری شامل اساتید دانشگاه و افراد متخصص فنی شرکت های سرمایه گذار فعال در این حوزه می باشند.
</p>
<p>
با توجه نمره فنی هر تیم در مرحله اول و نمره ارائه حضوری در مرحله دوم تیم های برتر مشخص خواهند شد و جوایز نقدی خود را دریافت خواهند کرد.
</p>
</div>
                            </GridItem>
                        </GridContainer>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
